import { ReactComponent as IconDataElement } from '@/assets/svgs/data-element.svg'

export const DataElementList = ({ data }) => {
	const receivingList = data?.dataElements?.map((item, _index) => {
		return (
			<>
				{item?.type === 'SEND' && (
					<div className='eclip-element-data-element-box'>
						<div className='data-element--flex-box'>
							<IconDataElement />
							<span className='data-element--label'>{item?.elementName}</span>
						</div>
						<hr />
					</div>
				)}
			</>
		)
	})

	const returningList = data?.dataElements?.map((item, _index) => {
		return (
			<>
				{item?.type === 'RECEIVER_SEND' && (
					<div className='eclip-element-data-element-box'>
						<div className='data-element--flex-box'>
							<IconDataElement />
							<span className='data-element--label'>{item?.elementName}</span>
						</div>
						<hr />
					</div>
				)}
			</>
		)
	})

	const NoMessgae = () => {
		return (
			<div className='eclip-element-data-element-box'>
				<div className='data-element--flex-box'>
					<span className='data-element--label'>No template Selected</span>
				</div>
				<hr />
			</div>
		)
	}

	return (

		<div className='eclip-create__data-element-wrapper'>
			<div className='eclip-create__data-element-container'>
				<div className='eclip-data-element--label'>
					Receiving
				</div>
				<hr />
				{receivingList?.length > 0 ? (
					<div>
						{receivingList}
					</div>
				) :
					<NoMessgae />
				}
			</div>


			<div className='eclip-create__data-element-container'>
				<div className='eclip-data-element--label'>
					Returning
				</div>
				<hr />
				{returningList?.length > 0 ? (
					<div>
						{returningList}
					</div>
				) :
					<NoMessgae />
				}

			</div>

		</div>
	)
}
